<template>
  <div class="custom-select-box" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <div class="selected-content">
        {{ selected ? selected[optionLabel] : defaultText }}
      </div>
      <span class="arrowDown">
        <span class="fa fa-angle-down" aria-hidden="true"></span>
      </span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div class="item" v-for="option in options" :key="option.id" @click="selectOption(option)">
        {{ option[optionLabel] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomSelectSso",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOption: {
      type: String
    },
    optionLabel: {
      type: String,
      default: "name"
    }
  },
  data() {
    return {
      selected: null,
      open: false
    };
  },
  computed: {
    defaultText() {
      return this.optionLabel === "name" ? "Select identity provider" : "Select Region";
    },
    selectedLabel() {
      return this.selected ? this.selected[this.optionLabel] : "";
    }
  },
  methods: {
    selectOption(option) {
      this.selected = option;
      this.open = false;
      this.$emit("input", option);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 14px;
  font-weight: normal;
}

.selected {
  background-color: #ffffff;
  color: #666669;
  padding-left: 11px;
  cursor: pointer;
  user-select: none;
  width: 210px;
  height: 34px;
  padding: 3px;
  border: solid 1px #ced4d9;
  border-radius: 4px;
  font-family: Roboto-Medium;
  padding: 6px;
  padding-left: 12px;
  color: #666669;
}
.arrowDown {
  position: absolute;
  top: 55%;
  right: 8px;
  transform: translateY(-50%);
}

.items {
  color: #000000;
  border-radius: 0px 0px 4px 4px;
  overflow: hidden;
  position: absolute;
  background-color: #ffffff;
  left: 1px;
  right: 1px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
  font-family: Roboto-Medium;
}

.item {
  padding-left: 11px;
  cursor: pointer;
  user-select: none;
  line-height: 2.57;
  border-bottom: 1px solid #dee2e6;
  font-family: Roboto-Regular;
  font-size: 14px;
  background-color: #fff;
  color: #4a4a4a;
  border-radius: 4px;
}

.item:hover {
  background-color: rgba(227, 227, 227, 0.6);
}

.selectHide {
  display: none;
}
</style>
